export const openHubSpotChat = () => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  window?.HubSpotConversations?.widget?.open()
}
